import React from 'react';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const { pathname } = useLocation();
  const isChat = pathname === '/chat' || pathname.startsWith('/chat/');

  return (
    <footer
      className={`${isChat ? 'hidden md:block' : ''} sticky bottom-0 z-20 shrink-0 bg-surface border-t border-border py-3 px-4 text-center text-sm text-muted-foreground`}
    >
      Coded by Kiem Dan Le @Babyponyshop
    </footer>
  );
};

export default Footer;
